import { render, staticRenderFns } from "./CadAutomacao.vue?vue&type=template&id=205aa153&"
import script from "./CadAutomacao.vue?vue&type=script&lang=js&"
export * from "./CadAutomacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports